import { SHARED_REACT_QUERY_CONFIG } from "../../constants/reactQuery.constant";
import { getAllAssistances } from "../../services/assistances/assistances.service";

export const ASSISTANCES_QUERY = "assistances";
export const ASSISTANCES_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const assistancesQuery = async () => {
  const request = await getAllAssistances();
  return request.data;
};
